import React from "react";
import { Dialog, Heading, Modal, ModalOverlay } from "react-aria-components";
import { AddToCartActionResponse } from "~/types/actions";
import { productNameFrom, sortBySize, toCapitalized } from "~/utils";
import { Product } from "~/types/product";
import { SelectedVariant } from "~/types/variant";

type Props = {
  product: Product;
  selectedVariant: SelectedVariant;
  actionResponse?: AddToCartActionResponse;
  isModalOpen: boolean;
  setIsModalOpen: (b: boolean) => void;
};

const SuccessModal: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  actionResponse,
  product,
  selectedVariant,
}) => {
  const imageUrl =
    selectedVariant.imageUrls.front?.thumbnail ??
    selectedVariant.imageUrls.back?.thumbnail ??
    selectedVariant.imageUrls.side?.thumbnail;

  return (
    <Modal
      isDismissable={true}
      isOpen={isModalOpen}
      onOpenChange={setIsModalOpen}
      className="add-to-cart__modal fixed left-[5%] top-4 z-[10000] flex w-[90%] flex-col items-center xsm:left-[calc(50%-210px)] xsm:top-[80px] xsm:w-[420px]"
    >
      <ModalOverlay className="fixed left-0 top-0 z-[10000] h-full w-full bg-black/65" />
      <Dialog className="w-full outline-none">
        <div className="flex w-full flex-col items-center bg-white pb-8">
          <Heading
            slot="title"
            className="add-t-cart__modal-header leading-0 w-full bg-blue p-[1rem] text-[1.25rem] text-white"
          >
            Items added to cart.{" "}
          </Heading>
          <div className="flex w-full flex-col items-center gap-3 p-4">
            <div className="flex w-full items-center border-b-1 border-b-gray pb-4">
              <img
                src={imageUrl}
                className="max-w-full"
              />
              <h2 className="text-sm text-black">
                {productNameFrom(product, false)}—
                {toCapitalized(selectedVariant.color)}
              </h2>
            </div>
            <p className="text-sm text-blue">
              has successfully been added to your cart!
            </p>
          </div>
          <div className="flex w-[300px] max-w-full flex-col items-center gap-4 px-2">
            <ul className="w-full px-2 text-black">
              {actionResponse?.data?.items
                .sort(sortBySize)
                .map((item, index) => (
                  <li
                    key={item.size}
                    className={`add-to-cart__modal-item flex items-start px-2 py-1 text-sm ${index % 2 === 0 ? "bg-white100" : ""}`}
                  >
                    <span className="mr-2">{item.size}</span>
                    <span>
                      {item.price} x {item.quantity}
                    </span>
                    <span className="ml-auto">{item.total}</span>
                  </li>
                ))}
            </ul>
            <button
              onClick={() => setIsModalOpen(false)}
              className="add-to-cart__modal-continue m-0 w-full rounded-[5px] bg-gradient-to-b from-black100 to-gray py-1 font-sans text-[1.125rem] font-normal text-white"
            >
              CONTINUE SHOPPING
            </button>
            <a
              href="/cart"
              className="w-full rounded-[5px] bg-blue py-1 text-center font-sans text-[1.125rem] font-normal text-white"
            >
              VIEW CART & CHECKOUT
            </a>
          </div>
        </div>
      </Dialog>
    </Modal>
  );
};

export default SuccessModal;
